/* VINTAGE SCUBA — The Rail. Butter-smooth: fixed-timestep springs, one write per frame,
   hover-intent (no flicker), cached geometry, pauses when off-screen. */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  var design = document.documentElement.classList.contains('shopify-design-mode') || (window.Shopify && window.Shopify.designMode);
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };

  function init(rail) {
    if (rail.__vsRail) return; rail.__vsRail = true;
    var track = rail.querySelector('[data-vs-track]');
    var inner = rail.querySelector('.vs-rail__inner');
    var items = [].slice.call(rail.querySelectorAll('[data-vs-item]'));
    if (!items.length) return;
    var amt = (parseFloat(rail.dataset.swing) || 0) / 100;
    var side = parseFloat(rail.dataset.side) || 0;

    var S = items.map(function (el, i) {
      return { el: el, sw: el.querySelector('[data-vs-swing]'), tag: el.querySelector('[data-vs-tag]'),
        a: 0, v: 0, t: 0, tv: 0, w: 0, px: 0.75 + ((i * 37) % 11) / 22, py: (i % 2 ? 1 : -0.8) * (0.7 + ((i * 53) % 7) / 14) };
    });

    /* ---------- spring loop (fixed 120Hz sub-steps → same feel on 60/90/120Hz) ---------- */
    var K = 72, C = 4.2, K2 = 115, C2 = 5.4;
    var driveX = 0, driveY = 0, running = false, last = 0, visible = true;

    function wake() { if (!running && amt > 0 && !reduce && visible) { running = true; last = performance.now(); requestAnimationFrame(tick); } }

    function tick(now) {
      var dt = Math.min(1 / 30, Math.max(0.001, (now - last) / 1000)); last = now;
      var n = Math.ceil(dt / (1 / 120)), h = dt / n, energy = 0;
      for (var k = 0; k < n; k++) {
        for (var i = 0; i < S.length; i++) {
          var s = S[i];
          var target = driveX * s.px + driveY * s.py;
          s.v += (-K * (s.a - target) - C * s.v) * h; s.a += s.v * h;
          s.tv += (-K2 * (s.t + s.a * 0.9) - C2 * s.tv) * h; s.t += s.tv * h;
        }
      }
      var decay = Math.exp(-dt * 5.5); driveX *= decay; driveY *= decay;
      for (var j = 0; j < S.length; j++) {
        var q = S[j];
        if (Math.abs(q.a - q.w) > 0.004) { q.sw.style.transform = 'rotate(' + q.a.toFixed(3) + 'deg)'; q.w = q.a; }
        if (q.tag) q.tag.style.transform = 'rotate(' + q.t.toFixed(3) + 'deg)';
        energy += Math.abs(q.a) + Math.abs(q.v) * 0.2 + Math.abs(q.t) + Math.abs(q.tv) * 0.2;
      }
      if (visible && (energy > 0.05 || Math.abs(driveX) + Math.abs(driveY) > 0.02)) requestAnimationFrame(tick);
      else { running = false; S.forEach(function (q) { q.a = q.v = q.t = q.tv = 0; q.sw.style.transform = ''; if (q.tag) q.tag.style.transform = ''; q.w = 0; }); }
    }
    function kick(i, v) { S[i].v += clamp(v, -110, 110) * amt; wake(); }

    /* ---------- inputs ---------- */
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      if (!visible) return;
      var dy = window.scrollY - lastY; lastY = window.scrollY;
      if (Math.abs(dy) < 1) return;
      driveY = clamp(driveY + dy * 0.09, -7, 7) * 1; wake();
    }, { passive: true });

    var lastSL = track.scrollLeft;
    track.addEventListener('scroll', function () {
      var dx = track.scrollLeft - lastSL; lastSL = track.scrollLeft;
      if (!dx) return;
      driveX = clamp(driveX - dx * 0.16, -14, 14); wake();
    }, { passive: true });

    /* ---------- geometry cache (un-shifted layout boxes → stable hit-testing) ---------- */
    var box = [];
    function measure() { box = items.map(function (el) { return { l: el.offsetLeft, r: el.offsetLeft + el.offsetWidth }; }); }
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(inner); else window.addEventListener('resize', measure);

    /* ---------- focus (hover intent, no flicker) ---------- */
    var active = -1, pending = -1, timer = 0;
    function setActive(idx) {
      if (idx === active) return; active = idx;
      items.forEach(function (el, i) {
        el.classList.toggle('is-active', i === idx);
        el.style.setProperty('--shift', idx < 0 ? '0px' : (i < idx ? -side : i > idx ? side : 0) + 'px');
      });
    }
    function indexAt(x) {
      var half = (parseFloat(getComputedStyle(inner).columnGap) || 0) / 2;
      for (var i = 0; i < box.length; i++) if (x >= box[i].l - half && x <= box[i].r + half) return i;
      return -1;
    }

    var lx = null, lt = 0;
    if (canHover) {
      track.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var now = performance.now(), ir = inner.getBoundingClientRect(), x = e.clientX - ir.left;
        var vx = lx === null ? 0 : (e.clientX - lx) / Math.max(6, now - lt);
        lx = e.clientX; lt = now;
        var idx = indexAt(x);
        // brush: nudge nearby hangers in the direction of travel
        if (Math.abs(vx) > 0.12) {
          for (var i = 0; i < box.length; i++) {
            var d = Math.abs(x - (box[i].l + box[i].r) / 2);
            if (d < 240) kick(i, vx * 70 * (1 - d / 240));
          }
        }
        // only commit to a garment once the pointer slows/rests on it
        var fast = Math.abs(vx) > 1.1;
        if (idx !== pending) { pending = idx; clearTimeout(timer); if (idx < 0) setActive(-1); else if (!fast) timer = setTimeout(function () { setActive(pending); }, active < 0 ? 90 : 40); }
        else if (idx >= 0 && active !== idx && !fast && !timer) timer = setTimeout(function () { setActive(pending); }, 60);
      }, { passive: true });
      rail.addEventListener('pointerleave', function () { lx = null; pending = -1; clearTimeout(timer); timer = 0; setActive(-1); });
      rail.addEventListener('focusin', function (e) { var i = items.indexOf(e.target.closest('[data-vs-item]')); if (i > -1) setActive(i); });
      rail.addEventListener('focusout', function (e) { if (!rail.contains(e.relatedTarget)) setActive(-1); });
    } else {
      // touch: first tap turns + lifts, second tap opens
      items.forEach(function (el, i) {
        var a = el.querySelector('a.vs-rail__link'); if (!a) return;
        a.addEventListener('click', function (e) {
          if (active === i) return;
          e.preventDefault(); setActive(i); kick(i, 60);
          var tr = track.getBoundingClientRect(), b = el.getBoundingClientRect();
          track.scrollTo({ left: track.scrollLeft + (b.left + b.width / 2) - (tr.left + tr.width / 2), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      document.addEventListener('pointerdown', function (e) { if (active > -1 && !rail.contains(e.target)) setActive(-1); }, { passive: true });
    }

    /* ---------- drop onto the rail ---------- */
    var drop = rail.dataset.drop === 'true' && !reduce && !design && 'IntersectionObserver' in window;
    if (drop) {
      rail.classList.add('is-armed');
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; io.disconnect();
        items.forEach(function (el, i) { el.classList.add('is-in'); setTimeout(function () { kick(i, (i % 2 ? 1 : -1) * 75); }, 520 + i * 80); });
      }, { threshold: 0.2 });
      io.observe(rail);
    } else items.forEach(function (el) { el.classList.add('is-in'); });

    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) wake(); }).observe(rail);
  }

  function boot() { document.querySelectorAll('[data-vs-rail]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
